import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-benefitsuse',
  templateUrl: './benefitsuse.component.html',
  styleUrls: ['./benefitsuse.component.scss']
})
export class BenefitsuseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
